import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeGA } from "./lib/analytics/gtag";
import { GA_MEASUREMENT_ID } from "./lib/analytics/config";

// Initialize Google Analytics
initializeGA(GA_MEASUREMENT_ID);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
